export const breakpoints = {
  xs: 0,
  sm: 720,
  md: 960,
  lg: 1280,
  xl: 1920,
};
